export default __webpack_public_path__ + "static/media/auto-certified.0d1c5111.svg";